import { BookOpenText, MessageCircle, Mic2, Settings2 } from "lucide-react";

export type MobileSheet = "voice" | "chat" | "chronicle" | "host";

export function MobileGameDock({
  active,
  isHost,
  voiceLabel,
  onOpen,
}: {
  active: MobileSheet | null;
  isHost: boolean;
  voiceLabel: string;
  onOpen: (sheet: MobileSheet) => void;
}) {
  const items: Array<{ id: MobileSheet; label: string; icon: typeof Mic2 }> = [
    { id: "voice", label: voiceLabel, icon: Mic2 },
    { id: "chat", label: "Chat", icon: MessageCircle },
    { id: "chronicle", label: "Biên niên sử", icon: BookOpenText },
    ...(isHost ? [{ id: "host" as const, label: "Host", icon: Settings2 }] : []),
  ];

  return (
    <nav className="mobile-game-dock" aria-label="Công cụ trong ván">
      {items.map(({ id, label, icon: Icon }) => (
        <button
          key={id}
          type="button"
          className={active === id ? "active" : ""}
          aria-pressed={active === id}
          onClick={() => onOpen(id)}
        >
          <Icon />
          <span>{label}</span>
        </button>
      ))}
    </nav>
  );
}
